// import React, { useState, useEffect, useCallback } from "react";
// import { Ticket, Plus, Trash2, RefreshCw, X, AlertCircle, Copy, Check } from "lucide-react";
// import { useAuth } from "../contexts/AuthContext";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";

// // ─── Helpers ──────────────────────────────────────────────────────────────────

// function randomPreview(prefix, middleName, suffix) {
//   const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
//   const rand = Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
//   const parts = [prefix, middleName, rand, suffix].filter(Boolean).map(s => s.toUpperCase());
//   return parts.join("-") || rand;
// }

// function isValid(v) {
//   if (v.redeemed) return false;
//   const now = new Date();
//   const end = new Date(v.endDate); end.setHours(23, 59, 59, 999);
//   return now >= new Date(v.startDate) && now <= end;
// }

// function StatusBadge({ voucher }) {
//   const valid = isValid(voucher);
//   if (voucher.redeemed) return (
//     <span className="font-mono text-xs px-2 py-0.5 rounded-full border border-surface-border text-text-muted bg-surface">
//       REDEEMED
//     </span>
//   );
//   if (valid) return (
//     <span className="font-mono text-xs px-2 py-0.5 rounded-full border border-green-500/30 text-green-400 bg-green-500/10">
//       ACTIVE
//     </span>
//   );
//   return (
//     <span className="font-mono text-xs px-2 py-0.5 rounded-full border border-red-500/30 text-red-400 bg-red-500/10">
//       EXPIRED
//     </span>
//   );
// }

// // ─── Main Component ───────────────────────────────────────────────────────────

// const EMPTY = {
//   prefix: "", middleName: "", suffix: "",
//   startDate: new Date().toISOString().slice(0, 10),
//   endDate: "", credits: 15,
// };

// export default function Vouchers() {
//   const { currentUser } = useAuth();
//   const [vouchers, setVouchers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [form, setForm] = useState(EMPTY);
//   const [preview, setPreview] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const [toast, setToast] = useState(null);
//   const [confirmDelete, setConfirmDelete] = useState(null);
//   const [copiedId, setCopiedId] = useState(null);

//   // ── Toast ─────────────────────────────────────────────────────────────────
//   const showToast = (msg, type = "success") => {
//     setToast({ msg, type });
//     setTimeout(() => setToast(null), 3500);
//   };

//   // ── Fetch vouchers ────────────────────────────────────────────────────────
//   const fetchVouchers = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/vouchers/all`);
//       const data = await res.json();
//       setVouchers(data.vouchers || []);
//     } catch {
//       showToast("Failed to load vouchers", "error");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => { fetchVouchers(); }, [fetchVouchers]);

//   // ── Form change → update preview ─────────────────────────────────────────
//   const handleChange = (e) => {
//     const updated = { ...form, [e.target.name]: e.target.value };
//     setForm(updated);
//     setPreview(randomPreview(updated.prefix, updated.middleName, updated.suffix));
//   };

//   // ── Create ────────────────────────────────────────────────────────────────
//   const handleCreate = async (e) => {
//     e.preventDefault();
//     if (Number(form.credits) < 15) return showToast("Minimum credits is 15", "error");
//     setSubmitting(true);
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/vouchers/create`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ...form, credits: Number(form.credits) }),
//       });
//       const data = await res.json();
//       if (!data.success) throw new Error(data.error);
//       showToast(`Voucher ${data.code} created!`);
//       setForm(EMPTY);
//       setPreview("");
//       fetchVouchers();
//     } catch (err) {
//       showToast(err.message, "error");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // ── Delete ────────────────────────────────────────────────────────────────
//   const handleDelete = async () => {
//     try {
//       await fetch(`${BACKEND_URL}/api/vouchers/${confirmDelete.id}`, { method: "DELETE" });
//       setConfirmDelete(null);
//       showToast("Voucher deleted.");
//       fetchVouchers();
//     } catch {
//       showToast("Failed to delete voucher", "error");
//     }
//   };

//   // ── Copy code ─────────────────────────────────────────────────────────────
//   const copyCode = (id, code) => {
//     navigator.clipboard.writeText(code);
//     setCopiedId(id);
//     setTimeout(() => setCopiedId(null), 2000);
//   };

//   // ─── Render ───────────────────────────────────────────────────────────────
//   return (
//     <div className="min-h-screen bg-surface pt-16 text-text-primary">
//       <div className="max-w-5xl mx-auto px-4 py-8">

//         {/* Toast */}
//         {toast && (
//           <div className={`fixed top-5 right-5 z-50 px-5 py-3 rounded-xl border font-body text-sm shadow-card
//             ${toast.type === "error"
//               ? "bg-red-950 border-red-500/40 text-red-300"
//               : "bg-green-950 border-green-500/40 text-green-300"}`}>
//             {toast.msg}
//           </div>
//         )}

//         {/* Confirm Delete Modal */}
//         {confirmDelete && (
//           <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center px-4">
//             <div className="bg-surface-elevated border border-surface-border rounded-2xl p-6 w-full max-w-sm shadow-card">
//               <div className="flex items-center gap-3 mb-4">
//                 <div className="w-10 h-10 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center">
//                   <AlertCircle className="w-5 h-5 text-red-400" />
//                 </div>
//                 <h3 className="font-display text-xl tracking-wider">Delete Voucher</h3>
//               </div>
//               <p className="font-body text-sm text-text-secondary mb-2">
//                 Delete voucher <span className="font-mono text-primary">{confirmDelete.code}</span>?
//               </p>
//               <p className="font-body text-xs text-red-400/80 mb-6">This cannot be undone.</p>
//               <div className="flex gap-3">
//                 <button onClick={() => setConfirmDelete(null)}
//                   className="flex-1 px-4 py-2.5 bg-surface border border-surface-border text-text-primary font-body rounded-lg hover:bg-surface-card transition-colors">
//                   Cancel
//                 </button>
//                 <button onClick={handleDelete}
//                   className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white font-body font-semibold rounded-lg flex items-center justify-center gap-2 transition-colors">
//                   <Trash2 className="w-4 h-4" /> Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Page Header */}
//         <div className="flex items-center justify-between mb-8">
//           <div>
//             <h1 className="font-display text-4xl tracking-wider">
//               VOUCHER <span className="text-primary">MANAGER</span>
//             </h1>
//             <p className="font-body text-sm text-text-secondary mt-1">
//               Create redeemable credit vouchers · minimum <span className="text-primary font-semibold">15 credits</span>
//             </p>
//           </div>
//           <button onClick={fetchVouchers}
//             className="flex items-center gap-2 px-4 py-2 border border-surface-border text-text-muted rounded-xl hover:border-primary/40 hover:text-primary transition-colors font-body text-sm">
//             <RefreshCw className="w-4 h-4" /> Refresh
//           </button>
//         </div>

//         {/* ── Create Form ── */}
//         <div className="bg-surface-elevated border border-surface-border rounded-2xl p-6 mb-8">
//           <h2 className="font-display text-2xl tracking-wider mb-6">
//             CREATE <span className="text-primary">NEW VOUCHER</span>
//           </h2>

//           <form onSubmit={handleCreate}>
//             {/* Code parts */}
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
//               {[
//                 { name: "prefix", label: "Prefix", placeholder: "e.g. TRX" },
//                 { name: "middleName", label: "Middle Name", placeholder: "e.g. SUMMER" },
//                 { name: "suffix", label: "Suffix", placeholder: "e.g. 2025" },
//               ].map(({ name, label, placeholder }) => (
//                 <div key={name}>
//                   <label className="font-body text-xs uppercase tracking-wider text-text-muted block mb-2">{label}</label>
//                   <input
//                     name={name}
//                     value={form[name]}
//                     onChange={handleChange}
//                     placeholder={placeholder}
//                     maxLength={12}
//                     className="w-full bg-surface border border-surface-border rounded-xl px-4 py-3 font-mono text-sm text-text-primary placeholder:text-text-muted focus:outline-none focus:border-primary transition-colors uppercase"
//                   />
//                 </div>
//               ))}
//             </div>

//             {/* Code preview */}
//             {preview && (
//               <div className="flex items-center gap-3 bg-surface border border-primary/20 rounded-xl px-4 py-3 mb-4">
//                 <Ticket className="w-4 h-4 text-primary flex-shrink-0" />
//                 <span className="font-body text-xs text-text-muted uppercase tracking-wider">Preview:</span>
//                 <span className="font-mono text-lg text-primary tracking-widest flex-1">{preview}</span>
//                 <button
//                   type="button"
//                   onClick={() => setPreview(randomPreview(form.prefix, form.middleName, form.suffix))}
//                   className="flex items-center gap-1 text-text-muted hover:text-primary font-body text-xs border border-surface-border px-3 py-1.5 rounded-lg transition-colors"
//                 >
//                   <RefreshCw className="w-3 h-3" /> Re-roll
//                 </button>
//               </div>
//             )}

//             {/* Dates + Credits */}
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
//               <div>
//                 <label className="font-body text-xs uppercase tracking-wider text-text-muted block mb-2">Start Date</label>
//                 <input type="date" name="startDate" value={form.startDate} onChange={handleChange} required
//                   className="w-full bg-surface border border-surface-border rounded-xl px-4 py-3 font-body text-sm text-text-primary focus:outline-none focus:border-primary transition-colors" />
//               </div>
//               <div>
//                 <label className="font-body text-xs uppercase tracking-wider text-text-muted block mb-2">End Date</label>
//                 <input type="date" name="endDate" value={form.endDate} onChange={handleChange} required
//                   className="w-full bg-surface border border-surface-border rounded-xl px-4 py-3 font-body text-sm text-text-primary focus:outline-none focus:border-primary transition-colors" />
//               </div>
//               <div>
//                 <label className="font-body text-xs uppercase tracking-wider text-text-muted block mb-2">Credits (min 15)</label>
//                 <input type="number" name="credits" value={form.credits} onChange={handleChange} min={15} required
//                   className="w-full bg-surface border border-surface-border rounded-xl px-4 py-3 font-body text-sm text-text-primary focus:outline-none focus:border-primary transition-colors" />
//               </div>
//             </div>

//             <button type="submit" disabled={submitting}
//               className="flex items-center gap-2 px-8 py-3 bg-primary text-surface font-body font-bold rounded-xl hover:bg-primary-dark transition-all shadow-glow disabled:opacity-60">
//               <Plus className="w-4 h-4" />
//               {submitting ? "Generating..." : "Generate Voucher"}
//             </button>
//           </form>
//         </div>

//         {/* ── Voucher Table ── */}
//         <div className="bg-surface-elevated border border-surface-border rounded-2xl overflow-hidden">
//           <div className="border-b border-surface-border px-6 py-4 flex items-center justify-between">
//             <div className="flex items-center gap-2">
//               <Ticket className="w-4 h-4 text-primary" />
//               <h3 className="font-display text-xl tracking-wider">ALL <span className="text-primary">VOUCHERS</span></h3>
//               <span className="font-mono text-xs text-text-muted bg-surface border border-surface-border px-2 py-0.5 rounded-full">
//                 {vouchers.length}
//               </span>
//             </div>
//           </div>

//           {loading ? (
//             <div className="flex items-center justify-center py-20 text-text-muted font-body text-sm">
//               Loading vouchers...
//             </div>
//           ) : vouchers.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-20 text-center">
//               <Ticket className="w-10 h-10 text-text-muted mb-3 opacity-30" />
//               <p className="font-body text-sm text-text-muted">No vouchers yet.</p>
//               <p className="font-body text-xs text-text-muted mt-1">Create your first one above.</p>
//             </div>
//           ) : (
//             <div className="overflow-x-auto">
//               <table className="w-full text-sm">
//                 <thead>
//                   <tr className="border-b border-surface-border">
//                     {["Status", "Code", "Credits", "Valid From", "Valid Until", "Redeemed By", ""].map(h => (
//                       <th key={h} className="text-left px-5 py-3 font-body text-xs uppercase tracking-wider text-text-muted">
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-surface-border">
//                   {vouchers.map((v) => (
//                     <tr key={v.id} className="hover:bg-surface transition-colors">
//                       <td className="px-5 py-4"><StatusBadge voucher={v} /></td>
//                       <td className="px-5 py-4">
//                         <div className="flex items-center gap-2">
//                           <span className="font-mono text-xs text-primary tracking-widest">{v.code}</span>
//                           <button onClick={() => copyCode(v.id, v.code)}
//                             className="text-text-muted hover:text-primary transition-colors">
//                             {copiedId === v.id
//                               ? <Check className="w-3 h-3 text-green-400" />
//                               : <Copy className="w-3 h-3" />}
//                           </button>
//                         </div>
//                       </td>
//                       <td className="px-5 py-4">
//                         <span className="font-display text-xl text-primary">{v.credits}</span>
//                       </td>
//                       <td className="px-5 py-4 font-body text-xs text-text-secondary">{v.startDate}</td>
//                       <td className="px-5 py-4 font-body text-xs text-text-secondary">{v.endDate}</td>
//                       <td className="px-5 py-4 font-mono text-xs text-text-muted">
//                         {v.redeemed ? (v.redeemedBy || "—") : "—"}
//                       </td>
//                       <td className="px-5 py-4">
//                         {!v.redeemed && (
//                           <button onClick={() => setConfirmDelete(v)}
//                             className="p-1.5 rounded-lg text-text-muted hover:text-red-400 hover:bg-red-500/10 transition-colors">
//                             <Trash2 className="w-3.5 h-3.5" />
//                           </button>
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
// src/pages/Vouchers.jsx
import React, { useState, useEffect, useCallback } from "react";
import { Ticket, Plus, Trash2, RefreshCw, AlertCircle, Copy, Check } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";

function randomPreview(prefix, middleName, suffix) {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  const rand = Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
  const parts = [prefix, middleName, rand, suffix].filter(Boolean).map(s => s.toUpperCase());
  return parts.join("-") || rand;
}

function isValid(v) {
  if (v.redeemed) return false;
  const now = new Date();
  const end = new Date(v.endDate); end.setHours(23, 59, 59, 999);
  return now >= new Date(v.startDate) && now <= end;
}

function StatusBadge({ voucher }) {
  if (voucher.redeemed) return (
    <span className="font-mono text-xs px-2 py-0.5 rounded-full border border-surface-border text-text-muted bg-surface">
      REDEEMED
    </span>
  );
  if (isValid(voucher)) return (
    <span className="font-mono text-xs px-2 py-0.5 rounded-full border border-green-500/30 text-green-400 bg-green-500/10">
      ACTIVE
    </span>
  );
  return (
    <span className="font-mono text-xs px-2 py-0.5 rounded-full border border-red-500/30 text-red-400 bg-red-500/10">
      EXPIRED
    </span>
  );
}

const EMPTY = {
  prefix: "", middleName: "", suffix: "",
  startDate: new Date().toISOString().slice(0, 10),
  endDate: "", credits: 15,
};

export default function Vouchers() {
  useAuth();
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(EMPTY);
  const [preview, setPreview] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [copiedId, setCopiedId] = useState(null);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  };

  const fetchVouchers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/vouchers/all`);
      const data = await res.json();
      setVouchers(data.vouchers || []);
    } catch {
      showToast("Failed to load vouchers", "error");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchVouchers(); }, [fetchVouchers]);

  const handleChange = (e) => {
    const updated = { ...form, [e.target.name]: e.target.value };
    setForm(updated);
    setPreview(randomPreview(updated.prefix, updated.middleName, updated.suffix));
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    if (Number(form.credits) < 15) return showToast("Minimum credits is 15", "error");
    setSubmitting(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/vouchers/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, credits: Number(form.credits) }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error);
      showToast(`Voucher ${data.code} created!`);
      setForm(EMPTY);
      setPreview("");
      fetchVouchers();
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setSubmitting(false);
    }
  };

  // ── Delete — now works for ALL vouchers including redeemed ────────────────
  const handleDelete = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/vouchers/${confirmDelete.id}`, { method: "DELETE" });
      const data = await res.json();
      if (!data.success) throw new Error(data.error);
      setConfirmDelete(null);
      showToast("Voucher deleted.");
      fetchVouchers();
    } catch (err) {
      showToast(err.message || "Failed to delete voucher", "error");
    }
  };

  const copyCode = (id, code) => {
    navigator.clipboard.writeText(code);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  return (
    <div className="min-h-screen bg-surface pt-16 text-text-primary">
      <div className="max-w-5xl mx-auto px-4 py-8">

        {/* Toast */}
        {toast && (
          <div className={`fixed top-5 right-5 z-50 px-5 py-3 rounded-xl border font-body text-sm shadow-card
            ${toast.type === "error"
              ? "bg-red-950 border-red-500/40 text-red-300"
              : "bg-green-950 border-green-500/40 text-green-300"}`}>
            {toast.msg}
          </div>
        )}

        {/* Confirm Delete Modal */}
        {confirmDelete && (
          <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center px-4">
            <div className="bg-surface-elevated border border-surface-border rounded-2xl p-6 w-full max-w-sm shadow-card">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center">
                  <AlertCircle className="w-5 h-5 text-red-400" />
                </div>
                <h3 className="font-display text-xl tracking-wider">Delete Voucher</h3>
              </div>
              <p className="font-body text-sm text-text-secondary mb-2">
                Delete voucher <span className="font-mono text-primary">{confirmDelete.code}</span>?
              </p>
              {confirmDelete.redeemed && (
                <p className="font-body text-xs text-yellow-400/80 mb-2">
                  ⚠️ This voucher has already been redeemed.
                </p>
              )}
              <p className="font-body text-xs text-red-400/80 mb-6">This cannot be undone.</p>
              <div className="flex gap-3">
                <button onClick={() => setConfirmDelete(null)}
                  className="flex-1 px-4 py-2.5 bg-surface border border-surface-border text-text-primary font-body rounded-lg hover:bg-surface-card transition-colors">
                  Cancel
                </button>
                <button onClick={handleDelete}
                  className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white font-body font-semibold rounded-lg flex items-center justify-center gap-2 transition-colors">
                  <Trash2 className="w-4 h-4" /> Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Page Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="font-display text-4xl tracking-wider">
              VOUCHER <span className="text-primary">MANAGER</span>
            </h1>
            <p className="font-body text-sm text-text-secondary mt-1">
              Create redeemable credit vouchers · minimum <span className="text-primary font-semibold">15 credits</span>
            </p>
          </div>
          <button onClick={fetchVouchers}
            className="flex items-center gap-2 px-4 py-2 border border-surface-border text-text-muted rounded-xl hover:border-primary/40 hover:text-primary transition-colors font-body text-sm">
            <RefreshCw className="w-4 h-4" /> Refresh
          </button>
        </div>

        {/* ── Create Form ── */}
        <div className="bg-surface-elevated border border-surface-border rounded-2xl p-6 mb-8">
          <h2 className="font-display text-2xl tracking-wider mb-6">
            CREATE <span className="text-primary">NEW VOUCHER</span>
          </h2>

          <form onSubmit={handleCreate}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              {[
                { name: "prefix", label: "Prefix", placeholder: "e.g. TRX" },
                { name: "middleName", label: "Middle Name", placeholder: "e.g. SUMMER" },
                { name: "suffix", label: "Suffix", placeholder: "e.g. 2025" },
              ].map(({ name, label, placeholder }) => (
                <div key={name}>
                  <label className="font-body text-xs uppercase tracking-wider text-text-muted block mb-2">{label}</label>
                  <input
                    name={name} value={form[name]} onChange={handleChange}
                    placeholder={placeholder} maxLength={12}
                    className="w-full bg-surface border border-surface-border rounded-xl px-4 py-3 font-mono text-sm text-text-primary placeholder:text-text-muted focus:outline-none focus:border-primary transition-colors uppercase"
                  />
                </div>
              ))}
            </div>

            {preview && (
              <div className="flex items-center gap-3 bg-surface border border-primary/20 rounded-xl px-4 py-3 mb-4">
                <Ticket className="w-4 h-4 text-primary flex-shrink-0" />
                <span className="font-body text-xs text-text-muted uppercase tracking-wider">Preview:</span>
                <span className="font-mono text-lg text-primary tracking-widest flex-1">{preview}</span>
                <button type="button"
                  onClick={() => setPreview(randomPreview(form.prefix, form.middleName, form.suffix))}
                  className="flex items-center gap-1 text-text-muted hover:text-primary font-body text-xs border border-surface-border px-3 py-1.5 rounded-lg transition-colors">
                  <RefreshCw className="w-3 h-3" /> Re-roll
                </button>
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div>
                <label className="font-body text-xs uppercase tracking-wider text-text-muted block mb-2">Start Date</label>
                <input type="date" name="startDate" value={form.startDate} onChange={handleChange} required
                  className="w-full bg-surface border border-surface-border rounded-xl px-4 py-3 font-body text-sm text-text-primary focus:outline-none focus:border-primary transition-colors" />
              </div>
              <div>
                <label className="font-body text-xs uppercase tracking-wider text-text-muted block mb-2">End Date</label>
                <input type="date" name="endDate" value={form.endDate} onChange={handleChange} required
                  className="w-full bg-surface border border-surface-border rounded-xl px-4 py-3 font-body text-sm text-text-primary focus:outline-none focus:border-primary transition-colors" />
              </div>
              <div>
                <label className="font-body text-xs uppercase tracking-wider text-text-muted block mb-2">Credits (min 15)</label>
                <input type="number" name="credits" value={form.credits} onChange={handleChange} min={15} required
                  className="w-full bg-surface border border-surface-border rounded-xl px-4 py-3 font-body text-sm text-text-primary focus:outline-none focus:border-primary transition-colors" />
              </div>
            </div>

            <button type="submit" disabled={submitting}
              className="flex items-center gap-2 px-8 py-3 bg-primary text-surface font-body font-bold rounded-xl hover:bg-primary-dark transition-all shadow-glow disabled:opacity-60">
              <Plus className="w-4 h-4" />
              {submitting ? "Generating..." : "Generate Voucher"}
            </button>
          </form>
        </div>

        {/* ── Voucher Table ── */}
        <div className="bg-surface-elevated border border-surface-border rounded-2xl overflow-hidden">
          <div className="border-b border-surface-border px-6 py-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Ticket className="w-4 h-4 text-primary" />
              <h3 className="font-display text-xl tracking-wider">ALL <span className="text-primary">VOUCHERS</span></h3>
              <span className="font-mono text-xs text-text-muted bg-surface border border-surface-border px-2 py-0.5 rounded-full">
                {vouchers.length}
              </span>
            </div>
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-20 text-text-muted font-body text-sm">
              Loading vouchers...
            </div>
          ) : vouchers.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center">
              <Ticket className="w-10 h-10 text-text-muted mb-3 opacity-30" />
              <p className="font-body text-sm text-text-muted">No vouchers yet.</p>
              <p className="font-body text-xs text-text-muted mt-1">Create your first one above.</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-surface-border">
                    {["Status", "Code", "Credits", "Valid From", "Valid Until", "Redeemed By", "Actions"].map(h => (
                      <th key={h} className="text-left px-5 py-3 font-body text-xs uppercase tracking-wider text-text-muted">
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-surface-border">
                  {vouchers.map((v) => (
                    <tr key={v.id} className="hover:bg-surface transition-colors">
                      <td className="px-5 py-4"><StatusBadge voucher={v} /></td>
                      <td className="px-5 py-4">
                        <div className="flex items-center gap-2">
                          <span className="font-mono text-xs text-primary tracking-widest">{v.code}</span>
                          <button onClick={() => copyCode(v.id, v.code)}
                            className="text-text-muted hover:text-primary transition-colors">
                            {copiedId === v.id
                              ? <Check className="w-3 h-3 text-green-400" />
                              : <Copy className="w-3 h-3" />}
                          </button>
                        </div>
                      </td>
                      <td className="px-5 py-4">
                        <span className="font-display text-xl text-primary">{v.credits}</span>
                      </td>
                      <td className="px-5 py-4 font-body text-xs text-text-secondary">{v.startDate}</td>
                      <td className="px-5 py-4 font-body text-xs text-text-secondary">{v.endDate}</td>
                      <td className="px-5 py-4 font-mono text-xs text-text-muted">
                        {v.redeemed ? (v.redeemedBy || "—") : "—"}
                      </td>
                      {/* ── Delete button now shows for ALL vouchers ── */}
                      <td className="px-5 py-4">
                        <button onClick={() => setConfirmDelete(v)}
                          className="p-1.5 rounded-lg text-text-muted hover:text-red-400 hover:bg-red-500/10 transition-colors">
                          <Trash2 className="w-3.5 h-3.5" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}